// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__4u84M","icon":"styles_icon__1Sy29","title":"styles_title__3lACZ"};